(function() {
  'use strict';

  if (typeof window.GameAPIService === 'undefined') {
    console.error('GameAPIService not loaded. Make sure game-api-service.js is loaded before this file.');
    return;
  }
  const gameAPI = new GameAPIService('cloud-jump', supaBase, window.currentUser);

  let gameStartTime = 0;
  let totalPlatformsJumped = 0;
  let totalPowerupsCollected = {
    small: 0,
    medium: 0,
    large: 0
  };
  let totalFakePlatformsAvoided = 0;
  let maxHeightReached = 0;

  let gameScore = 0;
  let gameLevel = 1;
  let cameraY = 0;

  // ========== Inizializzazione ==========

  async function initializeGameAPI() {
    try {
      const [personalBest, globalRecord, leaderboard] = await Promise.all([
        gameAPI.getPersonalBest(),
        gameAPI.getGlobalRecord(),
        gameAPI.getLeaderboard(5)
      ]);

      window.cloudJumpAPI = {
        personalBest: personalBest,
        globalRecord: globalRecord,
        leaderboard: leaderboard
      };
    } catch (error) {
      console.error('Error initializing API:', error);
    }
  }

  // ========== Override getCurrentGameState ==========

  gameAPI.getCurrentGameState = function() {
    return {
      score: gameScore,
      level: gameLevel,
      height: Math.abs(cameraY),
      timeElapsed: performance.now() - gameStartTime,
      platformsJumped: totalPlatformsJumped,
      powerupsCollected: totalPowerupsCollected,
      fakePlatformsAvoided: totalFakePlatformsAvoided,
      maxHeight: maxHeightReached,
      viewport: window.cloudJumpCurrentViewport
    };
  };

  // ========== Event Handlers per il Gioco ==========

  async function onGameStart() {
  
    gameStartTime = performance.now();
    totalPlatformsJumped = 0;
    totalPowerupsCollected = {
      small: 0,
      medium: 0,
      large: 0
    };
    totalFakePlatformsAvoided = 0;
    maxHeightReached = 0;

    const sessionStarted = await gameAPI.startGameSession();
    
    if (!sessionStarted) {
      console.warn('Failed to start game session, but continuing with game...');
    }

    return sessionStarted;
  }

  function onPlatformJumped(platformType) {
    totalPlatformsJumped++;
    
    if (platformType === 'fake') {
      totalFakePlatformsAvoided++;
    }
  }

  function onPowerupCollected(powerupType) {
    totalPowerupsCollected[powerupType]++;
  }

  function updateGameState(score, level, camera, viewport) {
    gameScore = score;
    gameLevel = level;
    cameraY = camera.y;

    if (viewport) {
      window.cloudJumpCurrentViewport = viewport;
    }
    
    const currentHeight = Math.abs(camera.y);
    if (currentHeight > maxHeightReached) {
      maxHeightReached = currentHeight;
    }
  }

  async function onGameEnd(finalScore, finalTime, displayInfo) {
    
    gameAPI.stopPeriodicChecks();

    const gameData = {
      score: finalScore,
      timeElapsed: finalTime,
      viewport: displayInfo,
      game_infos: {
        platformsJumped: totalPlatformsJumped,
        powerupsCollected: totalPowerupsCollected,
        fakePlatformsAvoided: totalFakePlatformsAvoided,
        maxHeight: maxHeightReached,
        avgScorePerSecond: Math.round(finalScore / (finalTime / 1000))
      }
    };

    const result = await gameAPI.submitScore(gameData);
    
    if (result.success) {
      
      const [newPersonalBest, newLeaderboard] = await Promise.all([
        gameAPI.getPersonalBest(),
        gameAPI.getLeaderboard(5)
      ]);

      window.cloudJumpAPI.personalBest = newPersonalBest;
      window.cloudJumpAPI.leaderboard = newLeaderboard;
    }

    gameAPI.cleanup();

    return {
      success: result.success,
      personalBest: window.cloudJumpAPI.personalBest,
      leaderboard: window.cloudJumpAPI.leaderboard
    };
  }

  // ========== Esponi API Pubblica per il Gioco ==========

  window.cloudJumpGameAPI = {
    initialize: initializeGameAPI,
    onGameStart: onGameStart,
    onGameEnd: onGameEnd,
    
    onPlatformJumped: onPlatformJumped,
    onPowerupCollected: onPowerupCollected,
    updateGameState: updateGameState,
    
    getPersonalBest: () => gameAPI.getPersonalBest(),
    getGlobalRecord: () => gameAPI.getGlobalRecord(),
    getLeaderboard: (limit) => gameAPI.getLeaderboard(limit),
    
    isSessionValid: () => gameAPI.isSessionValid(),
    getSessionId: () => gameAPI.sessionId
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGameAPI);
  } else {
    initializeGameAPI();
  }
})();